import { Box, Card, Stack, Tab, Tabs, Typography, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import { CardImg, CardImgMobile, TypCategories, TypTitle } from './style'
import { GrowthToolDescriptionProps } from '../../../types/entitys/growthTool'
import { PureLightTheme } from '../../../styles/theme'
import { GrowthToolInfo } from '../GrowthToolInfo'
import { EntityImagePreviewModal } from '../../common/EntityImagePreviewModal'
import { useEntityImagePreview } from '../../common/useEntityImagePreview'
import { ImageGalleryModal } from '../../ImageGalleryModal'
import { IconImagesLeft } from '../../../icons/IconImagesLeft'
import { IconImagesRight } from '../../../icons/IconImagesRight'
import {
  BoxTabs,
  ImageItem,
  ImageTab,
  TabsStyle,
} from '../../ProjectPage/Sections/Description/style'

export const GrowthToolDescription = ({ growthTool }: GrowthToolDescriptionProps) => {
  const isTablet = useMediaQuery(PureLightTheme.breakpoints.down('md'))
  const {
    canPreview,
    openPreview,
    closePreview,
    galleryOpen: coverGalleryOpen,
    galleryImages: coverGalleryImages,
  } = useEntityImagePreview(growthTool.image)
  const previewSx = canPreview ? { ...CardImg, cursor: 'pointer' as const } : CardImg
  const previewSxMobile = canPreview
    ? { ...CardImgMobile, cursor: 'pointer' as const }
    : CardImgMobile

  const imageGallery = (growthTool.image_gallery ?? []).filter((src) => Boolean(src?.trim()))
  const [galleryOpen, setGalleryOpen] = useState(false)
  const [galleryInitialIndex, setGalleryInitialIndex] = useState(0)

  const openGallery = (index: number) => {
    setGalleryInitialIndex(index)
    setGalleryOpen(true)
  }

  return (
    <Box>
      <Stack direction="row" mb={2}>
        {growthTool.image ? (
          <Box
            component="img"
            src={growthTool.image}
            alt="Image"
            sx={previewSx}
            onClick={canPreview ? openPreview : undefined}
          />
        ) : (
          <Box sx={CardImg} />
        )}
        <Box>
          {growthTool.image ? (
            <Box
              component="img"
              src={growthTool.image}
              alt="Image"
              sx={previewSxMobile}
              onClick={canPreview ? openPreview : undefined}
            />
          ) : null}
          <Typography variant="h1" sx={TypTitle}>{growthTool.title}</Typography>
        </Box>
      </Stack>
      <Box mb={2}>
        {isTablet && <GrowthToolInfo growthTool={growthTool} />}
      </Box>
      {imageGallery.length > 0 && (
        <Box sx={BoxTabs}>
          <Tabs
            value={false}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={TabsStyle}
            slots={{
              StartScrollButtonIcon: IconImagesLeft,
              EndScrollButtonIcon: IconImagesRight,
            }}
          >
            {imageGallery.map((src, index) => (
              <Tab
                key={`${src}-${index}`}
                disableRipple
                sx={ImageTab}
                onClick={() => openGallery(index)}
                icon={
                  <Box
                    component="img"
                    src={src}
                    alt="Image"
                    sx={ImageItem}
                  />
                }
              />
            ))}
          </Tabs>
        </Box>
      )}
      <Card variant="primaryAdaptiveCard">
        <Typography variant="h3" sx={TypCategories}>Описание</Typography>
        <Typography variant="body1" component="div" sx={{ whiteSpace: 'pre-wrap' }}>
          {growthTool.description}
        </Typography>
      </Card>
      <EntityImagePreviewModal
        open={coverGalleryOpen}
        onClose={closePreview}
        images={coverGalleryImages}
      />
      <ImageGalleryModal
        open={galleryOpen}
        onClose={() => setGalleryOpen(false)}
        images={imageGallery}
        initialIndex={galleryInitialIndex}
      />
    </Box>
  )
}
